// src/services/data.js
// Operaciones de datos sobre la API (PostgreSQL). Los totales, la caja chica y el KPI
// se calculan en el servidor; el frontend solo envía los datos del formulario.
import { apiGet, apiPost, apiPut, apiPatch, apiDelete } from './api';

const enc = encodeURIComponent;
const qs = (obj) => {
  const p = new URLSearchParams();
  Object.entries(obj || {}).forEach(([k, v]) => { if (v != null && v !== '') p.append(k, v); });
  const s = p.toString();
  return s ? `?${s}` : '';
};

// Sucursales
export const listSucursales = () => apiGet('/data/sucursales');
export const getSucursal = (id) => apiGet(`/data/sucursales/${enc(id)}`);
export const createSucursal = (payload) => apiPost('/data/sucursales', payload);
export const updateSucursal = (id, payload) => apiPut(`/data/sucursales/${enc(id)}`, payload);
export const deleteSucursal = (id) => apiDelete(`/data/sucursales/${enc(id)}`);

// Cierres (cuadres)
export const listCierres = (filtros) => apiGet(`/data/cierres${qs(filtros)}`);
export const getCierre = (id) => apiGet(`/data/cierres/${enc(id)}`);
export const createCierre = (payload) => apiPost('/data/cierres', payload);
export const updateCierre = (id, payload) => apiPut(`/data/cierres/${enc(id)}`, payload);
export const patchCierreFaltante = (id, faltantePagado) =>
  apiPatch(`/data/cierres/${enc(id)}/faltante`, { faltantePagado });
export const deleteCierre = (id) => apiDelete(`/data/cierres/${enc(id)}`);

// Pagos
export const listPagos = (filtros) => apiGet(`/data/pagos${qs(filtros)}`);
export const getPago = (id) => apiGet(`/data/pagos/${enc(id)}`);
export const createPago = (payload) => apiPost('/data/pagos', payload);
export const updatePago = (id, payload) => apiPut(`/data/pagos/${enc(id)}`, payload);
export const deletePago = (id) => apiDelete(`/data/pagos/${enc(id)}`);

// Categorías (listas configurables por ámbito)
export const getCategorias = (scope) => apiGet(`/data/categorias${qs({ scope })}`);
export const saveCategorias = (scope, categorias) => apiPut('/data/categorias', { scope, categorias });

// Comprobantes: se convierte el archivo a base64 y devuelve la URL pública (UUID aleatorio)
function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result).replace(/^data:[^;]+;base64,/, ''));
    reader.onerror = () => reject(reader.error || new Error('No se pudo leer el archivo'));
    reader.readAsDataURL(file);
  });
}
export async function subirComprobante(blob, nombre, mime) {
  const dataBase64 = await fileToBase64(blob);
  const r = await apiPost('/data/archivos', {
    nombre: nombre || blob.name || 'comprobante',
    mime: mime || blob.type || 'application/octet-stream',
    dataBase64,
  });
  return r.url;
}

// Usuarios (solo admin)
export const listUsuarios = () => apiGet('/admin/usuarios');
export const createUsuario = (payload) => apiPost('/admin/createUser', payload);
export const updateUsuario = (payload) => apiPost('/admin/updateUser', payload);
export const deleteUsuario = (uid) => apiPost('/admin/deleteUser', { uid });
